// extracted by mini-css-extract-plugin
export default {"Box":"SubIssueAddedEvent-module__Box--FNMk0","Box_1":"SubIssueAddedEvent-module__Box_1--PVN5X"};